export const RESCHEDULE_CLASSES_STAGES = {
  notOpen: 'notOpen',
  view: 'view',
  details: 'details',
  confirmation: 'confirmation',
  validation: 'validation',
};
